import uniqueId from 'lodash/uniqueId';

import { ReduxThunkType } from '../../types/ReduxThunkType';
import { Actions as NotificationsActions } from './actions';
import { DEFAULT_AUTOHIDE_DELAY, GlobalNotification } from './types';
import { GlobalNotificationTypes } from '../../enums/GlobalNotificationTypes';
import { t } from '../../../../i18n';

export const spawnGlobalNotification =
  (notification: GlobalNotification): ReduxThunkType<void> =>
  (dispatch) => {
    const uniqueNotification = {
      ...notification,
      id: uniqueId(),
      delay: notification.delay || DEFAULT_AUTOHIDE_DELAY
    };
    dispatch(NotificationsActions.spawnGlobalNotification(uniqueNotification));
  };

export const spawnSaveSuccessGlobalNotification = (): ReduxThunkType<void> => (dispatch) => {
  dispatch(
    spawnGlobalNotification({
      type: GlobalNotificationTypes.Success,
      message: t('common.notification.success.message'),
      title: t('common.notification.success')
    })
  );
};
